// deps
import React, { ReactElement, memo, ReactNode } from "react";
import classNames from "classnames";
import { AriaHidden } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import styles from "./Alert.v4.scss";

export interface AlertProps {
    message: string | ReactNode;
    className?: string;
    "data-testid"?: string;
}

function Alert(props: AlertProps): ReactElement | null {
    if (!props.message || (typeof props.message === "string" && props.message.length <= 0)) {
        return null;
    }

    const alertClass = classNames(styles.alert, props.className);

    return (
        <AriaHidden as="div" className={alertClass}>
            <Text
                as="p"
                variant="V2.body3.neutral.regular"
                color="negative"
                className={styles.alertMessage}
                data-testid={props["data-testid"]}
            >
                {props.message}
            </Text>
        </AriaHidden>
    );
}

export default memo(Alert);
